<template>
  <!-- Toast look: this holder takes no space, so the toast floats over the page instead of pushing it down -->
  <div :class="{ 'app-toast-holder': $toastAlerts }">
  <div
    v-if="visible"
    :class="['alert', alertClass, 'fade show p-2', $toastAlerts ? 'app-toast' : 'position-relative', { 'app-alert-bottom': $alertPosition === 'bottom' }, { show: visible }]"
    role="status"
  >
  <!-- Toast look (main.js: toastAlerts = true): an icon in front -->
  <i v-if="$toastAlerts" class="fa fa-fw me-2" :class="iconClass"></i>
  <strong :style="{ fontSize: $toastAlerts ? '1em' : '1.3em' }">{{ message }}</strong>

  <img
    v-if="isSubmitting && type === 'info'"
    src="/img/progress.gif"
    height="10"
  />
  <button type="button" class="btn-close position-absolute top-0 end-0 m-2" @click="visible = false"></button>
</div>
</div>
</template>
<script>
export default {
  props: {
    message: String,
    type: {
      type: String,
      default: "success", // Default type is success
    },
    alertstatus: {
      type: String,
      default: "", // Default value is empty string, or you can set a more meaningful default
    }
  },
  data() {
    return {
      visible: false,
      isSubmitting: false,
      hideTimer: null // timer that hides success (3 s) and danger (5 s) messages
    };
  },
  computed: {
    alertClass() {
      const classes = {
        success: "alert-success",
        primary: "alert-primary",
        danger: "alert-danger",
        warning: "alert-warning",
        info: "alert-info",
        nonClass: ""
      };
      return classes[this.type] || "alert-info"; // Default to info if type is unknown
    },
    iconClass() {
      const icons = {
        success: "fa-check",
        danger: "fa-times",
        warning: "fa-exclamation-triangle",
        info: "fa-info-circle",
        nonClass: ""
      };
      return icons[this.type] || ""; // Default to info icon
    },
  },
  watch: {
    message(newMessage) {
      if (newMessage && this.alertstatus === "starting") {
        clearTimeout(this.hideTimer); // a new message: an old timer must not hide it
        this.isSubmitting = true;
        this.visible = true;
        this.hideLater("starting"); // a danger message (e.g. a form error) disappears too
      } else if (this.alertstatus === "ending") {
        this.visible = true;//added today 20th april 2025
        this.isSubmitting = false;
        this.hideLater("ending"); // success and danger messages disappear by themselves
      }
    },
    alertstatus(newStatus) {
      if (newStatus === "starting") {
        clearTimeout(this.hideTimer); // a new message: an old timer must not hide it
        this.isSubmitting = true;
        this.visible = true; //added today 20th april 2025
        this.hideLater("starting"); // a danger message (e.g. a form error) disappears too
      } else if (newStatus === "ending") {
        this.visible = true;
        this.isSubmitting = false;
        this.hideLater("ending"); // success and danger messages disappear by themselves
      }
    }
  },
  methods: {
    // Success: hides after 3 seconds. Danger: after 5 seconds (time to read the error).
    // Warning, info: stay until the user clicks ×
    hideLater(status) {
      clearTimeout(this.hideTimer);
      const delays = { success: 3000, danger: 5000 };
      const delay = delays[this.type];
      if (!delay) return;
      // "Uploading..." and other progress messages (starting) stay while they work: only danger hides then
      if (status === "starting" && this.type !== "danger") return;
      this.hideTimer = setTimeout(() => {
        this.visible = false;
        this.isSubmitting = false;
      }, delay);
    },
  },
  beforeUnmount() {
    // Leaving the page: don't leave the timer running
    clearTimeout(this.hideTimer);
  },
};
</script>
<style scoped>
/* Toast look (main.js: toastAlerts = true). Floats over the page at the same spot */
.app-toast-holder {
  position: relative;
  height: 0;          /* takes no space: nothing below moves */
  z-index: 1060;      /* above tables, cards and dropdowns */
}
.app-toast {
  position: absolute;
  top: -3rem;      /* higher up: a negative number moves it up, a positive one down */
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  width: max-content;
  max-width: 100%;
  margin: 0;
  padding: 0.6rem 2.75rem 0.6rem 1rem !important;
  border: 0;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
  animation: app-toast-in 0.25s ease-out;
}


.app-toast .btn-close {
  top: 50% !important;
  transform: translateY(-50%);
  margin: 0 0.75rem !important;
  font-size: 0.7rem;
}
@keyframes app-toast-in {
  from { opacity: 0; transform: translate(-50%, -8px) scale(0.98); }
  to   { opacity: 1; transform: translate(-50%, 0); }
}

/* main.js alertPosition = 'bottom': floats at the bottom middle of the screen (page and window) */
.app-alert-bottom {
  position: fixed !important;
  top: auto;
  bottom: 1.25rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1060;             /* above the window (Bootstrap modals are 1055) */
  width: max-content;
  max-width: calc(100% - 2rem);
  margin: 0;
  padding-right: 2.75rem !important; /* room for the × */
  animation: app-alert-up 0.25s ease-out;
}
@keyframes app-alert-up {
  from { opacity: 0; transform: translate(-50%, 8px); }
  to   { opacity: 1; transform: translate(-50%, 0); }
}
</style>